export default __webpack_public_path__ + "static/media/SS5-min.7a270ffc.png";